import trotaPhoto from '../media/trota.png';
import martinezPhoto from '../media/martinez.png';
import walmartPhoto from '../media/person2.png';

/**
 * Testimoniales del home.
 *
 * Antes esto era un JSON con rutas de texto tipo '../media/trota.png'. Esas
 * rutas nunca pasan por el bundler: el navegador las resolvía contra la URL de
 * la página y las tres fotos daban 404 en producción. Importando la imagen,
 * webpack la copia al build y nos entrega la URL final con su hash.
 */
const testimonials = [
  {
    id: 'trotatourism',
    name: 'Ana Hernández',
    company: 'TROTATOURISM',
    photo: trotaPhoto,
    quote:
      'Tengo ya un año siendo cliente de Axioma Network; ellos salvaron a mi empresa de un diseño de imagen catastrófico y la han ido puliendo poco a poco, desde imagen e inclusive organización. Siempre están disponibles para dudas, inclusive las más sencillas.',
  },
  {
    id: 'martinez',
    name: 'Lic. Marcos Martínez',
    company: 'Martínez y Asociados',
    photo: martinezPhoto,
    quote:
      'Mi experiencia siendo cliente de la empresa digital Axioma ha sido totalmente confortable durante todo el tiempo que me han prestado sus servicios; en todo momento han sido muy responsables, diligentes, audaces y sobre todo muy profesionales.',
  },
  // PENDIENTE: este testimonial tenía texto de relleno en inglés ("Though the
  // gravity still dragged at him...") publicado como si fuera una cita real.
  // Sustituye `quote` por las palabras textuales de la clienta, o borra la
  // entrada completa: el carrusel funciona con dos testimoniales.
  {
    id: 'walmart',
    name: 'Karla Fregoso',
    company: 'Walmart',
    photo: walmartPhoto,
    quote: '',
  },
];

export default testimonials;
